import { createAsyncThunk } from "@reduxjs/toolkit";

import logger from "Libs/logger";
import { AsyncThunkOptionType } from "Reducers/types";

import { getActivityTypes } from "../activity.slice";
import { getIntegrationActivitiesRequest } from "Api/activity/getIntegrationActivities.request";

import type { LoadIntegrationActivities } from "../types";
import type { Activity } from "Api/activity/types";

export const loadIntegrationActivities = createAsyncThunk<
  {
    activities: Activity[];
    hasMore: boolean;
    organizationDescriptionId: string;
    projectDescriptionId: string;
    integrationDescriptionId: string;
    integrationActivity: string[];
  },
  LoadIntegrationActivities,
  AsyncThunkOptionType
>(
  "app/activity/integration/load",
  async (
    {
      organizationDescriptionId,
      projectDescriptionId,
      integrationDescriptionId,
      filterNames
    },
    { rejectWithValue }
  ) => {
    const filters = getActivityTypes(filterNames);
    // Don't make any request when no filter is selected
    if (!filters.length) {
      return {
        activities: [],
        hasMore: false,
        organizationDescriptionId,
        projectDescriptionId,
        integrationDescriptionId,
        integrationActivity: []
      };
    }
    try {
      const encodedIntegrationId = encodeURIComponent(integrationDescriptionId);

      const activities = await getIntegrationActivitiesRequest({
        projectId: projectDescriptionId,
        encodedIntegrationId,
        filters
      });

      let hasMore = false;
      if (activities.length > 9) {
        hasMore = true;
        activities.pop();
      }

      const activitiesForIntegration = activities.map(activity => activity.id);

      return {
        activities,
        hasMore,
        organizationDescriptionId,
        projectDescriptionId,
        integrationDescriptionId,
        integrationActivity: activitiesForIntegration
      };
    } catch (err: any) {
      if (![404, 403].includes(err.code)) {
        logger(err, {
          action: "integration_load_activities",
          meta: {
            organizationDescriptionId,
            projectDescriptionId,
            integrationDescriptionId
          }
        });
      }
      return rejectWithValue(err);
    }
  }
);
